module.exports = __webpack_public_path__ + "img/wconcept.73d55303.png";